import axios from "../lib/axios";
import $ from "jquery";
import xml2json from "../lib/xml2json";


export const get = (url, params) => {
    
    return axios.get(url, {
        params
    })
    .then(({ data }) => $.parseXML(data))
    .then(xml => xml2json(xml))
    .then(resp => {
        if ('undefined' !== typeof resp.mensagem && 'undefined' !== typeof resp.mensagem.erro) {
            throw new Error(resp.mensagem.erro.descricao);
        }
        return resp;
    });
};

export default {
    get
};
